/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useReducer } from "react";
import { Nav, Spinner } from "react-bootstrap";
import VKservice from "../services/VKservice";
import VKcontext from "../context/VKcontext";
import { friendsState, friendsReducer } from "../store/friendsReducer";
const Friends = () => {
  const vk = new VKservice();
  const { active, setActive, token } = useContext(VKcontext);
  const [state, dispatch] = useReducer(friendsReducer, friendsState );
  const loadFriends = async () => {
    await dispatch({ type: "FETCH_FRIENDS" });
    const res = await vk.getFriends(token);
    if (!res) {
      await dispatch({ type: 'FRIENDS_ERROR'})
    } else {
      await dispatch({ type: "FRIENDS_LOADED", payload: res });
    }
  };
  useEffect(() => {
    loadFriends();
  }, []);

  if (state.error) {
    return <h1 className='mt2'>Ошибка загрузки</h1>
  }

  if (state.loading) {
    return <Spinner animation="border" className="mt2" />;
  }

  return (
    <Nav className="flex-column bg-light border-right friends" variant='pills'>
      {state.friends.map(item => {
        const hasAcvtive = item.id === active ? true : false;
        return (
          <Nav.Item key={item.id}>
          <Nav.Link
          className='navlink border-bottom'
            active={hasAcvtive}
            onClick={() => setActive(item.id)}
            
          >{`${item.first_name}­ ${item.last_name}`}</Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  );
};

export default Friends;
